export * from './IconDiamond';
